import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store"; // ✅ Asegúrate de que esta ruta es correcta

const PUBLIC_PATHS = ["/", "/login", "/register"];
const normalizePath = (path) => (path || "").replace(/\/+$/, "") || "/";

const shouldAutoRedirect = () => {
  const current = normalizePath(window.location.pathname);
  return !PUBLIC_PATHS.includes(current);
};

const redirectToLogin = () => {
  if (!shouldAutoRedirect()) return;

  const hasToken = !!localStorage.getItem("token");
  if (!hasToken) return;

  localStorage.removeItem("token");
  localStorage.removeItem("userData");
  window.location.replace("/login");
};

// Interceptor global: si el token caduca/invalid (status o mensaje), limpiamos sesión y redirigimos a login
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  const response = await originalFetch(...args);

  try {
    if (!shouldAutoRedirect()) {
      return response;
    }

    if (response.status === 401 || response.status === 403) {
      redirectToLogin();
      return response;
    }

    const cloned = response.clone();
    const contentType = cloned.headers.get("content-type") || "";
    if (contentType.includes("application/json") || contentType.startsWith("text/")) {
      const bodyText = (await cloned.text()) || "";
      const lowered = bodyText.toLowerCase();
      if (
        lowered.includes("invalid token") ||
        lowered.includes("token invalido") ||
        lowered.includes("token inválido") ||
        lowered.includes("jwt expired")
      ) {
        redirectToLogin();
      }
    }
  } catch (e) {
    console.warn("No se pudo verificar el token en la respuesta:", e);
  }

  return response;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
